import * as Yup from 'yup';

const EVENT_TYPES = [
    "Acto Institucional", "Taller", "Conferencia", "Foro", "Seminario",
    "Webinar", "Capacitación", "Charla", "Panel", "Congreso"
];

export const initValuesEvent = {
    reason_title: '',
    eventType: '',
    start_date: null,
    end_date: null,
    url: '',
    url_button_name: '',
    reason_list: [],
    image: null,
};

export const validationSchemaEvent = Yup.object({
    reason_title: Yup.string()
        .required('El título es requerido')
        .max(80, 'El título no puede exceder 80 caracteres'),
    eventType: Yup.string()
        .required('El tipo de evento es requerido')
        .oneOf(EVENT_TYPES, 'Tipo de evento inválido'),
    start_date: Yup.date()
        .required('La fecha de inicio es requerida')
        .nullable(),
    end_date: Yup.date()
        .required('La fecha de fin es requerida')
        .nullable()
        .min(Yup.ref('start_date'), 'La fecha de fin debe ser posterior a la de inicio'),
    url: Yup.string()
        .required('La URL es requerida'),
    url_button_name: Yup.string()
        .required('El nombre del botón es requerido'),
});

export { EVENT_TYPES };
